module.exports = __webpack_public_path__ + "static/media/findersspeakers-logo-white.8c7cec71.png";